import { APPS } from "./registry/apps";
import { computeProgress } from "./lib/progress";
import { usePrefersReducedMotion } from "./lib/motion";
import { Mosaic } from "./components/Mosaic";
import { ProgressHUD } from "./components/ProgressHUD";
import { AppDirectory } from "./components/AppDirectory";
import { Grain } from "./components/Grain";

const MARQUEE =
  "VIBE-CODED · SHIPPED DAILY · PUBLIC QUEST · 9000 LIVE APPS · 31 DEC 2026 · MOSAIC APEX · *.OVER9000.CC · NO AUTH · NO FEED · JUST THE WALL · ";

export default function App() {
  const reducedMotion = usePrefersReducedMotion();
  const progress = computeProgress(APPS);

  return (
    <div className="page">
      <a className="skip" href="#inventory">
        Skip to inventory
      </a>

      <Grain reducedMotion={reducedMotion} />

      <section className="hero">
        <Mosaic apps={APPS} progress={progress} reducedMotion={reducedMotion} />
        <div className="hero-veil" aria-hidden="true" />
        <ProgressHUD progress={progress} />

        <div className="lockup">
          <p className="kicker">Public quest · apex mosaic · over9000.cc</p>
          <h1>
            <span className="line-over">OVER</span>
            <span className="line-nine">9000</span>
          </h1>
          <p className="tag">
            Vibe-code it. Ship it on a subdomain. Stick the screenshot on the wall. Stop at
            nine thousand live apps — or 31 Dec 2026.
          </p>
        </div>

        <p className="spine" aria-hidden="true">
          31 DEC 2026 · HIT 9000 · SHIP DAILY
        </p>
      </section>

      <div className="marquee" aria-hidden="true">
        <div className={`marquee-track ${reducedMotion ? "is-still" : ""}`}>
          <span>{MARQUEE.repeat(4)}</span>
        </div>
      </div>

      <AppDirectory apps={APPS} />

      <footer className="site-foot">
        <div>
          <p className="foot-mark">OVER 9000</p>
          <p>
            Hub only. This site does not host other apps. Each live title lives on its own
            subdomain and (usually) its own Pages project.
          </p>
        </div>
        <ul>
          <li>
            <span>HUB</span>
            <a href="https://github.com/mypaperpet/over9000.cc">mypaperpet/over9000.cc</a>
          </li>
          <li>
            <span>ORG</span>
            <a href="https://github.com/over-9000">github.com/over-9000</a>
          </li>
          <li>
            <span>SHIP</span>
            <a href="https://github.com/mypaperpet/over9000.cc/blob/main/docs/SHIP.md">
              docs/SHIP.md
            </a>
          </li>
          <li>
            <span>ZONE</span>
            <a href="https://over9000.cc">over9000.cc</a>
          </li>
        </ul>
      </footer>
    </div>
  );
}
